import api from '../_api'
import {
    FETCH_COST_TAGS_REQUEST,
    FETCH_COST_TAGS_SUCCESS,
    FETCH_COST_TAGS_FAILED,
    FETCH_COST_TAGS_CATEGORY_REQUEST,
    FETCH_COST_TAGS_CATEGORY_SUCCESS,
    FETCH_COST_TAGS_CATEGORY_FAILED,
    FETCH_COST_TAGS_RESOURCEID_REQUEST,
    FETCH_COST_TAGS_RESOURCEID_SUCCESS,
    FETCH_COST_TAGS_RESOURCEID_FAILED,
    /** Tags */
    FETCH_TAGS_ALL_REQUEST,
    FETCH_TAGS_ALL_SUCCESS,
    FETCH_TAGS_ALL_FAILED
} from './mutation-type'

const getCostTags = async ({ commit, state, getters, rootGetters }, { projectIdx, month, tagKey }) => {
    commit(FETCH_COST_TAGS_REQUEST)
    try {
        const { data, status } = await api.fetchCostTags({ projectIdx, month, tagKey }, rootGetters.requiredService)
        commit(FETCH_COST_TAGS_SUCCESS, { data: data.data, status })
        return data
    } catch (error) {
        commit(FETCH_COST_TAGS_FAILED, error)
        throw error
    }
}

const getCostTagsByCategory = async ({ commit, state, getters, rootGetters }, { projectIdx, month, tagKey, tagValue, index }) => {
    commit(FETCH_COST_TAGS_CATEGORY_REQUEST)
    try {
        const { data, status } = await api.fetchCostTagsByCategory({ projectIdx, month, tagKey, tagValue }, rootGetters.requiredService)
        commit(FETCH_COST_TAGS_CATEGORY_SUCCESS, { data: data.data, status, index })
        return data
    } catch (error) {
        commit(FETCH_COST_TAGS_CATEGORY_FAILED, error)
        throw error
    }
}

const getCostTagsByResourceId = async ({ commit, state, getters, rootGetters }, { projectIdx, month, tagKey, tagValue, productCode, productCategory, index, rootIndex }) => {
    commit(FETCH_COST_TAGS_RESOURCEID_REQUEST)
    try {
        const { data, status } = await api.fetchCostTagsByResourceid({ projectIdx, month, tagKey, tagValue, productCode, productCategory }, rootGetters.requiredService)
        commit(FETCH_COST_TAGS_RESOURCEID_SUCCESS, { data: data.data, index, rootIndex, status })
        return data
    } catch (error) {
        commit(FETCH_COST_TAGS_RESOURCEID_FAILED, error)
        throw error
    }
}
/** hyper common */
const getTagsAll = async ({ commit, state, getters, rootGetters }) => {
    commit(FETCH_TAGS_ALL_REQUEST)
    try {
        const { data } = await api.getTagsAll(rootGetters.requiredService)
        commit(FETCH_TAGS_ALL_SUCCESS, data)
        return data
    } catch (error) {
        commit(FETCH_TAGS_ALL_FAILED, error)
        throw error
    }
}
export default {
    getCostTags,
    getCostTagsByCategory,
    getCostTagsByResourceId,
    /** Tags */
    getTagsAll
}
